import SalarieNumeroSecu from '@/generated/controls/salarie/SalarieNumeroSecu.vue';
import { defineComponent } from "vue";
import validator, {rules, RULES_FRENCH_LABEL} from "@/generated/validators/ValidationRules.ts";

export default defineComponent({ components: {},
    extends: SalarieNumeroSecu,
    methods: {
        // eslint-disable-next-line
        focusValidator(value: string): validator | null {
            return null;
        },

        // eslint-disable-next-line
        liveValidator(value: string): validator | null {
            if (value && value.length == 10) {
                return new validator(rules.numeroSecuProvisoire, RULES_FRENCH_LABEL.text.numeroSecuProvisoire.error);
            } else {
                return new validator(rules.numeroSecu, RULES_FRENCH_LABEL.text.numeroSecu.error);
            }
        },

        // eslint-disable-next-line
        mask(value: string): string {
            if (value && value.length <= 10) {
                return 'N NN NN NX';
            } else {
                return 'N NN NN NX NNN NNN NN';
            }
        },
    }
})
